import { createContext, useContext } from "react";

const BookDemoContext = createContext(null);

export function useBookDemo() {
  const context = useContext(BookDemoContext);
  if (!context) {
    throw new Error("useBookDemo must be used within BookDemoProvider");
  }
  return context;
}

export default BookDemoContext;
